"use client";
import React, { useState } from "react";
import { Drawer } from "antd";
import { useSharedData } from "bossjob-remote/dist/hooks";
import styles from "./JobHeader.mobile.module.scss";
import { CloseIcon, DropDownIcon, ExchangeIcon } from "./Icons";

const ExchangeDrawer = ({ list, setValue, onCloseHandler, value, convertToLabel }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <span
        className={styles.exchangeBtn}
        onClick={() => {
          setOpen(true);
        }}
      >
        <ExchangeIcon />
        <DropDownIcon />
      </span>
      <Drawer
        height='60vh'
        className={styles.mobileExchangeDrawer}
        title={
          <div className={styles.mobileExchangeDrawerHeader}>
            <span>{convertToLabel}</span>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='20'
              height='20'
              viewBox='0 0 20 20'
              fill='none'
              onClick={() => setOpen(false)}
            >
              <path
                d='M15.3033 5.87523C15.6288 5.54979 15.6288 5.02215 15.3033 4.69671C14.9779 4.37128 14.4502 4.37128 14.1248 4.69671L10 8.8215L5.87523 4.69671C5.54979 4.37128 5.02215 4.37128 4.69671 4.69671C4.37128 5.02215 4.37128 5.54979 4.69671 5.87523L8.8215 10L4.69671 14.1248C4.37128 14.4502 4.37128 14.9779 4.69671 15.3033C5.02215 15.6288 5.54979 15.6288 5.87523 15.3033L10 11.1785L14.1248 15.3033C14.4502 15.6288 14.9779 15.6288 15.3033 15.3033C15.6288 14.9779 15.6288 14.4502 15.3033 14.1248L11.1785 10L15.3033 5.87523Z'
                fill='#ACAEB1'
              ></path>
            </svg>
            {/* <span
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon />
            </span> */}
          </div>
        }
        placement='bottom'
        width='100vw'
        closable={false}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        getContainer={() => document.body}
      >
        {list.map((v) => {
          return (
            <div
              key={v?.id}
              className={styles.mobileExchangeDrawerListItem}
              data-checked={v.text === value}
              onClick={(e) => {
                e.stopPropagation();
                setValue(v.text);
                setOpen(false);
                onCloseHandler(e, v.text);
              }}
            >
              <span style={{ display: "flex", alignItems: "center" }}>
                <img style={{ width: 24, height: 24, marginRight: 6 }} src={v.currency_icon} />{" "}
                {v.currency_code}
              </span>
              <span className={styles.mobileExchangeDrawerListItemSalary}>{v.text}</span>
            </div>
          );
        })}
      </Drawer>
    </>
  );
};

export const MoneyExchange = ({ data, onCloseHandler }) => {
  const langDic = useSharedData("DICTIONARY") || {};
  const [value, setValue] = useState(data.originalValue);

  const convertTo = langDic?.moneyExchange?.convertTo;

  if (data.is_show_exchange) {
    return (
      <ExchangeDrawer
        list={data.exchange}
        setValue={setValue}
        value={value}
        convertToLabel={convertTo}
        onCloseHandler={(event, value) => {
          event.stopPropagation?.();
          onCloseHandler(value);
        }}
      />
    );
  }
  return null;
};

export default MoneyExchange;
